import { Component, OnInit, ViewChild } from '@angular/core';
import { GridReadyEvent, RowNode, SelectionChangedEvent } from 'ag-grid-community';
import { BodisplayComponent } from '../../../../../bodisplay';
import { BObjectModel, ModeBo, QResult, QueovalBase, QueovalDate} from '../../../../../models';
import { PlanningOnglet, ReservationPlanning, ReservationPlanningAndIdStage } from '../../../../../models/formation/planning.model';
import { CoreService, HttpService, QueovalDateService } from '../../../../../services';
import { StageService } from '../../services/stage-modal.service';
import { PlanningService } from '../planning.service';




/**
 * Affecte des réservations existantes au stage du stageService (filtrées par rapport au bureau)
 * */
@Component({
  selector: 'q-reservations-bureau',
  templateUrl: './reservations-bureau.component.html',
  styleUrls: ['./reservations-bureau.component.css'],
})
export class ReservationsBureauComponent implements OnInit {

  /** Accesseur au bo find (pour en utiliser les méthodes) */
  @ViewChild('boFind', { static: false, read: BodisplayComponent }) set _boFindPere(bofind: BodisplayComponent) {
    if (bofind) {
      this.boFind = bofind;
    }
  };

  /** passé au q-bodisplay en mode Find*/
  public modeBo: typeof ModeBo = ModeBo;
  /** modèle ne comportant que les codes bo et relation afin d'afficher le bo find correspondant*/
  public modelBo: BObjectModel = new BObjectModel();
  /** image du composant enfant q-bodisplay */
  public boFind: BodisplayComponent;

  /** clause where retournée par le bo find*/
  public strWhere: string = '';

  /** bureau sélectionné (par défaut celui de l'utilisateur connecté */
  public idBureau: string = "0";
  /** date de début (par défaut date de début du stage en cours */
  public dateDebut: QueovalDate;
  /** date de fin (par défaut date de fin du stage en cours */
  public dateFin: QueovalDate;

  //booléens pour afficher/masqer la grid et le bo
  public displayGrid: boolean = false;
  public displayBo: boolean = false;

  public customgridName: string = 'ListeReservationsParBureau';
  //raffraîchi la grid
  public refreshData: boolean = false;

  /**liste des identifiants des réservations sélectionnées */
  public ListResas: Array<ReservationPlanning> = [];

  public isLoading: boolean = false;

  constructor(
    public stageService: StageService,
    public planningService: PlanningService,
    public qDateService: QueovalDateService,
    private http: HttpService,
    private indParam: CoreService,
  ) { }

  ngOnInit(): void {
    this.idBureau = this.planningService.idBureauUtilisateurConnecte != "" ? this.planningService.idBureauUtilisateurConnecte : "0";
    this.dateDebut = this.planningService.DateDebut;
    this.dateFin = this.planningService.DateFin;

    this.modelBo.IdentBO = 'BO_RESERV';
    this.modelBo.IdRelation = 'REL_BO_BUREAU_BO_RESERV';
    this.modelBo.IdDonneeFils = '0';
    this.modelBo.IdDonneePere = '0';
  }

  /** applique les filtres avant de raffraîchir la grid */
  public getFilter(): void {
    this.strWhere = '';
    //le choix d'un bureau est obligatoire
    //contrôle qu'un bureau est bien sélectionné
    if (!this.idBureau || this.idBureau == '-1' || this.idBureau == '0') {
      this.displayGrid = false;
      return;
    }
    //si le boFind est ouvert on récupère le where qu'il génère
    if (this.displayBo && this.boFind) {
      this.strWhere = this.boFind.getWhere('eve');
    }

    //filtre sur le bureau
    if (this.strWhere)
      this.strWhere = `l2.Pere_LIE = ${this.idBureau} AND ${this.strWhere}`;
    else {
      this.strWhere = `l2.Pere_LIE = ${this.idBureau}`;
    }

    //filtre sur la date de début
    if (!this.qDateService.IsNull(this.dateDebut)) {
      if (this.strWhere)
        this.strWhere = `eve.DatedEVE >= '${this.qDateService.ToString(this.dateDebut, 'yyyy-dd-MM')}' AND ${this.strWhere}`;
      else {
        this.strWhere = `eve.DatedEVE >= '${this.qDateService.ToString(this.dateDebut, 'yyyy-dd-MM')}'`;
      }
    }

    //filtre sur la date de fin
    if (!this.qDateService.IsNull(this.dateFin)) {
      if (this.strWhere)
        this.strWhere = `eve.DatedEVE <= '${this.qDateService.ToString(this.dateFin, 'yyyy-dd-MM')} 23:59:59' AND ${this.strWhere}`;
      else {
        this.strWhere = `eve.DatedEVE <= '${this.qDateService.ToString(this.dateFin, 'yyyy-dd-MM')} 23:59:59'`;
      }
    }

    //affiche la grid et la rafraîchit
    this.displayGrid = true;
    this.refreshData = true;
  }

  /** lance la recherche */
  public OnSearch(): void {
    if (this.boFind)
      this.boFind.externalSave();
    else
      this.getFilter();
  }

  /** retour à la vue planning */
  public Undo(): void {
    this.planningService.View = PlanningOnglet.Planning;
  }

  /** créer les liens entre les reservations sélectionnées et le stage en cours */
  public OnSave(): void {
    const model: ReservationPlanningAndIdStage = new ReservationPlanningAndIdStage();

    model.IdStage = this.stageService.Stage.Ident;
    model.reservations = this.ListResas;
    this.isLoading = true;
    this.http.postHttp<QResult<boolean>>(`${this.indParam.AppParams.apiUrl}api/Stage/Planning/INSERT_LIEN_RESERV`, model).subscribe(() => {
      this.isLoading = false;
      this.planningService.RefreshReserv();
      this.planningService.View = PlanningOnglet.Planning;
    });
  }

  /**
   * récupère les lignes sélectionnées dans la grid
   * @param e évenement de sélection change de ag-grid
   */
  public selectLine(e: SelectionChangedEvent): void {
    this.ListResas = e.api.getSelectedRows().map(row => {
      const model: ReservationPlanning = new ReservationPlanning();
      model.Ident = `${row['Ident']}`;
      return model;
    });
  }

  /**
   * pré-sélectionne les réservations déjà attachées au stage dans la grid (quand elle a fini de se charger)
   * @param event évenement ready de ag-grid
   */
  public onGridReady(event: GridReadyEvent) {
    event.api.forEachLeafNode((node: RowNode) => {
      if (this.planningService.ListeReservations.filter((resa: ReservationPlanning) => {return `${resa.Ident}` == `${node.data.Ident}`;}).length > 0)
      {
        node.setSelected(true);
      }
    });
  }
}
